import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddEbook, IEbook } from "../../Ebook.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddEbook = () => {
  const [formData, setFormData] = useState<IAddEbook>({
    languageName: "",
    courseName: "",
    standard: "",
    subject: "",
    bookName: "",
    eBookPrice: 0,
    isPhysicalBookAvailable:'NA',
    physicalBookPrice:0,
    description: "",
    availability: true,
    imageUrl: null,
    pdfUrl: null,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [ebook, setEbook] = useState<IEbook | null>(null);
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const isPhyiscalBookAvailable = [{isPhysicalBookAvailable:'Available'},{isPhysicalBookAvailable:'NA'}]
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const [standard, setStandard] = useState<any[]>([]);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { id, value } = e.target;
    const files = (e.target as HTMLInputElement).files;
  
    if (id === "imageUrl" || id === "pdfUrl") {
      setFormData((prevState) => ({
        ...prevState,
        [id]: files ? files[0] : null,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };
  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [
        coursesResponse,
        languagesResponse,
        subjectResponse,
        standardResponse,
      ] = await Promise.all([
        ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getSubject }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);

      setCourses(coursesResponse);
      setLanguages(languagesResponse);
      setSubjectName(subjectResponse);
      setStandard(standardResponse);
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages."); // Show error toast
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit: SubmitHandler<IAddEbook> = async () => {
    try {
      setLoading(true)
      const formDataToSend = new FormData();
      formDataToSend.append("languageName", formData.languageName);
      formDataToSend.append("courseName", formData.courseName);
      formDataToSend.append("standard", formData.standard);
      formDataToSend.append("subjectName", formData.subject);
      formDataToSend.append("bookName", formData.bookName);
      formDataToSend.append("eBookPrice", String(formData.eBookPrice));
      formDataToSend.append("isPhysicalBookAvailable", formData.isPhysicalBookAvailable);
      formDataToSend.append("physicalBookPrice", String(formData.physicalBookPrice));
      formDataToSend.append("description", formData.description);
      formDataToSend.append("availability", formData.availability.toString());

      // Attach files if present
      if (formData.imageUrl) {
        formDataToSend.append("imageUrl", formData.imageUrl);
      }
      if (formData.pdfUrl) {
        formDataToSend.append("pdfUrl", formData.pdfUrl);
      }

      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createbook}`,
        data: formDataToSend,
        headers: {
          "Content-Type": "multipart/form-data", // Required for file uploads
        },
      });

      if (response) {
        toast.success("Ebook added successfully");
        navigate("/ebook");
      }
    } catch (error) {
      toast.error("Error adding ebook");
      console.error("Error adding ebook:", error);
    }finally{
      setLoading(false)
    }
  };

  const handleCancel = () => {
    navigate("/ebook");
  };
  // Fetch data when the component mounts
  useEffect(() => {
    fetchCoursesAndLanguages(); // Fetch courses and languages
  }, []);

  return {
    loading,
    formData,
    ebook,
    courses,
    languages,
    subjectName,
    standard,
    isPhyiscalBookAvailable,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddEbook;
